module.exports = __webpack_public_path__ + "media/images/img_completed-bootcamp-1fa2c58bc72cc69783211ee713ff6883.png";